"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_1 = require("@devexpress/dx-react-grid");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var exportTableToExcel_1 = require("portal/components/Grid/helpers/exportTableToExcel");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
var permissiontypes_1 = require("../Users/permissiontypes");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var categoriesSlice_1 = require("src/features/categories/categoriesSlice");
function CategoriesTable() {
    var _this = this;
    var data = (0, reduxHooks_1.useAppSelector)(function (state) { return state.categories; }).data;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t("common.categories"));
    (0, react_1.useEffect)(function () {
        dispatch((0, categoriesSlice_1.fetchCategoriesInBatches)());
        var unsubscribe = (0, categoriesSlice_1.subscribeToCategories)(dispatch);
        return function () {
            unsubscribe();
        };
    }, [dispatch]);
    var commitChanges = function (_a) {
        var added = _a.added, changed = _a.changed;
        if (added) {
            added.map(function (row) { return __awaiter(_this, void 0, void 0, function () {
                var categoriesData;
                return __generator(this, function (_a) {
                    categoriesData = data.map(function (e) {
                        return e.name.toLowerCase();
                    });
                    if (categoriesData.includes(row.name.toLowerCase())) {
                        antd_1.message.error(t("alerts.categoryNameAlreadyyExists"));
                    }
                    else {
                        dispatch((0, categoriesSlice_1.addCategory)(row)).then(function () {
                            antd_1.message.success(t("alerts.success"));
                        });
                    }
                    return [2 /*return*/];
                });
            }); });
        }
        if (changed) {
            (0, lodash_1.map)(changed, function (changedFields, docId) {
                dispatch((0, categoriesSlice_1.editCategory)(__assign({ id: docId }, changedFields))).then(function () {
                    antd_1.message.success(t("alerts.success"));
                });
            });
        }
    };
    var dataSource = data;
    var columns = [
        {
            name: "name",
            title: t("common.name"),
        },
        {
            name: "requireBatchNumber",
            title: t("common.requireBatchNumber"),
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([(0, jsx_runtime_1.jsx)(dx_react_grid_1.EditingState, { onCommitChanges: commitChanges }), (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["requireBatchNumber"], editorComponent: function (_a) {
                        var value = _a.value, onValueChange = _a.onValueChange, row = _a.row;
                        if (!row) {
                            return null;
                        }
                        return ((0, jsx_runtime_1.jsx)(antd_1.Checkbox, { checked: value, onChange: function (e) { return onValueChange(e.target.checked); }, disabled: !!(row === null || row === void 0 ? void 0 : row.id) }));
                    }, formatterComponent: function (_a) {
                        var value = _a.value;
                        return ((0, jsx_runtime_1.jsx)("span", { children: value ? "True" : "False" }));
                    } })], (0, defaultDevExtremeGridComponents_1.default)({
                allowHidingColumns: false,
                groups: false,
            }), true), [(0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableEditRow, {}), (0, permissiontypes_1.permissionTypes)("createEditCategory", currentUser === null || currentUser === void 0 ? void 0 : currentUser.permissions) ? ((0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableEditColumn, { showAddCommand: true, showEditCommand: true })) : null, (0, permissiontypes_1.permissionTypes)("exportCategories", currentUser === null || currentUser === void 0 ? void 0 : currentUser.permissions) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                        position: "absolute",
                        right: "90px",
                        marginTop: 16,
                        zIndex: 999,
                    }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var fileName, fields, titles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    fileName = "Categories Table";
                                    fields = ["id", "name"];
                                    titles = ["id", t("common.name")];
                                    return [4 /*yield*/, (0, exportTableToExcel_1.exportTablesToExcel)(data, fields, titles, fileName)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: t("common.exportToExcel") }))) : null], false) })) }));
}
exports.default = CategoriesTable;
